import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';


/**
 * 创建下拉单选框组件
 * @param config 配置
 */
export const createTooltip = (props: Partial<TooltipProps>, target: HTMLElement) => {
  const { left, top, width } = target.getBoundingClientRect();
  const container = document.createElement('div');
  container.classList.add('Lp4EditorTooltipContainer');
  document.body.appendChild(container);

  props.title = <div dangerouslySetInnerHTML={{ __html: props.title + '' }}></div>;

  ReactDOM.render((
    <Tooltip {...props} visible={true}>
      <button style={{
        position: 'fixed',
        overflow: 'hidden',
        width: 0,
        height: 0,
        padding: 0,
        border: 'none',
        left: left + width / 2,
        top
      }}></button>
    </Tooltip>
  ), container);

  return () => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };
};
